export default __webpack_public_path__ + "static/media/16.165c4741.jpg";